import { ReturnTranslatedText } from '@wajeez-web/core/localization';

interface FieldContentProps {
  label: string | undefined;
  value: string | number | undefined;
}

export const FieldContent = ({ label, value }: FieldContentProps) => {
  return (
    <div className="w-full">
      <div className="text-[16px] font-medium">
        <ReturnTranslatedText
          text={`inputs.labels.${label}`}
          origintext={label}
        />
      </div>
      <div className="mt-1 p-2 rounded bg-warmGray-200 text-[14px] font-normal">
        {value}
      </div>
    </div>
  );
};
